export default {
  data () {
    return {
      searchTerm: this.getQuerySearchTerm(),
      appliedSearchTerm: ''
    }
  },
  methods: {
    commitSearchTerm (queryFixer = null) {
      this.appliedSearchTerm = this.searchTerm
      const searchTermKey = this.getQuerySearchTermKey()
      const query = JSON.parse(JSON.stringify(this.$route.query || {}))
      delete query.broswernav

      if (!this.searchTerm) {
        delete query[searchTermKey]
      } else {
        query[searchTermKey] = this.searchTerm
      }

      if (queryFixer instanceof Function) {
        queryFixer(query)
      }

      // this.$router.replace(
      //   {
      //     name: this.$route.name,
      //     query: null
      //   },
      //   () => {
      //     this.$router.replace({
      //       name: this.$route.name,
      //       query: query
      //     })
      //   }
      // )

      this.$router.push({
        name: this.$route.name,
        query: query
      })
    },
    getQuerySearchTermKey (prefix = '') {
      return (prefix ? prefix + '_' : '') + 'search_term'
    },
    getQuerySearchTerm () {
      return this.$route.query[this.getQuerySearchTermKey()]
    },
    setQuerySearchTerm (val = null) {
      if (val !== null) {
        this.searchTerm = val
      } else if (this.hasQuerySearchTerm()) {
        this.searchTerm = this.getQuerySearchTerm()
      }
    },
    hasQuerySearchTerm () {
      return !!this.$route.query[this.getQuerySearchTermKey()]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/HasListFilter.mixin.js